import { permissionObj } from "../../../../Helpers/permission";
import {accessMethodModel} from "../../../../enums/accessMethodEnum";
/**
 * @Author      Susana García Rodríguez
 * @JobTitle    Frontend Developer
 * @Email       sgarcia@ibl.mx
 */

export const DAILY_SERVICES_SIZE = 50;
export const FOUR_SECONDS = 4000;

export const DELIVERED_SERVICES_SEARCH_MODEL = {
    cafeteriaId : null,
    search: "",
    date: null,
    clear: () =>{
        return {
            ...this,
            cafeteriaId: null,
            search: "",
            date: null
        }
    }
}

export const TABS_DELIVERED_SERVICES = {
    SERVICES: {
        INDEX: 0,
        TRANS: "services_of_the_day",
    },
    HISTORY: {
        INDEX: 1,
        TRANS: "history",
    },
}


export const MODEL_HEADER = {
    diner: null,
}

export const MODEL_CONTEXT_DELIVERED_SERVICES = {
    tabIndex: null,
}

export function TAB_PERMISSION_DELIVERED_SERVICES() {
    return {
        EXPORT: {
            [TABS_DELIVERED_SERVICES.SERVICES.INDEX]:
                permissionObj?.WEB_FOODIE_KITCHEN_ACCESS_EXPORT,
            [TABS_DELIVERED_SERVICES.HISTORY.INDEX]:
                permissionObj?.WEB_FOODIE_KITCHEN_ACCESS_HISTORY_EXPORT
        },
    };
}

export const DELIVERED_SERVICES_TYPE = {
    [accessMethodModel.QR_CODE.id]: {
        TRANS: "lunch_box",
        ICON: accessMethodModel.QR_CODE.icon,
    },
    [accessMethodModel.FACE_RECOGNITION.id]: {
        TRANS: "regular_meal",
        ICON: accessMethodModel.FACE_RECOGNITION.icon,
    },
};
